export const indexUrl = "/"

//export const ourStoryUrl = "/our_story";
//export const aboutUrl = "/about";
export const globalMarketsUrl = "/global_markets";

export const exclusiveMarketDataUrl = "/exclusive_market_data";
export const mobileSupportUrl = "/mobile_support";
//export const fairPlayUrlUrl = "/fair_play";
export const forPeopleAndPlanetUrl = "/people_and_planet";

//export const customerServiceUrl = "/customer_service";
export const contactUsUrl = "/contact";
//export const reportIssueUrl = "/report_a_issue";

export const stockListScreenUrl = "/stocks";
export const stockDetailsUrl = "/stock";

export const indicesListScreenUrl = "/indexes";
export const indicesDetailsUrl = "/index";

export const cryptoListScreenUrl = "/cryptos"
export const cryptoDetailsUrl = "/crypto"


export const termsUrl = "/terms";
export const privacyUrl = "/privacy";

export const loginUrl = "/sign_in"
export const registerUrl = "/registration"
export const logoutUrl = "/sign_out"

export const userDashboardUrl = "/home"
export const discoverStocksUrl = "/discover_stocks"

export const registrationSuccess = "/registration_success"
export const activateUserUrl = '/activate'

//export const aboutCompanyFooterLinks = {

//    'Global markets': globalMarketsUrl,
//   'Credits': creditsUrl,
//}
/*  'Our story': ourStoryUrl,
    'About': aboutUrl,*/
// closed stray JSX-style comments
export const yourBenefitsFooterLinks = {
    'Exclusive market data': exclusiveMarketDataUrl,
    'Full mobile support': mobileSupportUrl,
    'For people and planet': forPeopleAndPlanetUrl,
}
/*'Fair pay': fairPlayUrlUrl,*/
// closed stray JSX-style comments

export const helpFooterLinks = {
    'Contact us': contactUsUrl,
}
/*    'Customer service': customerServiceUrl,
    'Report a issue': reportIssueUrl,

*/

